import { MentionNode } from '#pplx/frontend/composer-sdk/lexical/nodes/MentionNode.js';
import { $applyNodeReplacement } from 'lexical';
export function $createMentionNode(props) {
    return $applyNodeReplacement(new MentionNode(props));
}
export function $isMentionNode(node) {
    return node instanceof MentionNode;
}
//# sourceMappingURL=MentionNodeSupport.js.map